var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fill: "#E50056",
    d: "M20,7.4c-0.1-0.3-0.3-0.5-0.6-0.5l-6-0.8l-2.8-5.6C10.5,0.2,10.2,0,9.9,0 C9.6,0,9.3,0.2,9.2,0.5L6.6,6.2l-6,1C0.4,7.2,0.1,7.4,0,7.7C-0.1,8,0,8.3,0.2,8.5l4.4,4.4l-0.9,6.3c0,0.3,0.1,0.6,0.3,0.7 C4.2,20,4.3,20,4.5,20c0.1,0,0.3,0,0.4-0.1l5.3-3l5.4,2.9c0.3,0.1,0.6,0.1,0.8-0.1c0.2-0.2,0.4-0.5,0.3-0.8l-1.1-6.3l4.3-4.5 C20,8,20.1,7.7,20,7.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarActive);
export default __webpack_public_path__ + "static/media/icon_star_active.518d783ad7b15e7713c8894fc2e35743.svg";
export { ForwardRef as ReactComponent };